import { type ApolloLink, split } from '@apollo/client';

import { getSubscriptionTransport } from '@/lib/ws/subscription-transport';

/**
 * 購読の転送方式（WebSocket か SSE）を、送信のたびに決めて振り分けるリンク。
 * 方式は環境の設定とブラウザごとの上書きで決まる。上書きは、画面の起動後に URL から保存されるので、作成時には固定しない。
 */
export function createSubscriptionLink(sseLink: ApolloLink, wsLink: ApolloLink): ApolloLink {
  return split(() => getSubscriptionTransport() === 'sse', sseLink, wsLink);
}
